<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="'single'">
    <ng-container *ngIf="linkObject | async as link">
      <a (click)="redirect(link.OBJECT_ID)">{{ link.TEXT }}</a>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'multiple'">
    <a (click)="openDetailsDialog(links)">
      {{ links.split(',').length }} {{ direction }} vorhanden
    </a>
  </ng-container>
</ng-container>
